// A simple magnifying glass SVG icon
const SearchIcon = ({ className = "", ...props }) => (
  <svg
    className={className}
    height="18"
    width="18"
    viewBox="0 0 20 20"
    fill="none"
    stroke="currentColor"
    {...props}
  >
    <circle cx="9" cy="9" r="7" strokeWidth="2" />
    <line x1="14.5" y1="14.5" x2="18" y2="18" strokeWidth="2" strokeLinecap="round" />
  </svg>
);
export default SearchIcon;